import { useCreateProjectFromCrmMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useCreateProjectFromCrm = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useCreateProjectFromCrmMutation(headerWithAuth, options);

  return mutate;
};

export {
  useCreateProjectFromCrm,
};
